import { Component  } from 'react';
import axios from "axios";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { addSettings } from "../../../actions";
import {
  getSingleRequest,
  getSingleViewRequest,
  viewJumpClientMetabaseReport,
} from "./../../../config/client_api_calls";

import $ from "jquery";

import BusinessInformation from "../../../components/Client/CreditApplication/BusinessInformation";
import FinancialInformation from "../../../components/Client/CreditApplication/FinancialInformation";
import TradeReferences from "../../../components/Client/CreditApplication/TradeReferences";
import SignatoryDetails from "../../../components/Client/CreditApplication/SignatoryDetails";
import SsoSuccess from "../../../components/Client/CreditApplication/Success";
import { BarChart } from "../../../components/ContentLoaders/newLoaders/BarChart";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
  ADMIN_API_URL,
} from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import TextField from "../../../components/InputFields/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import dateFormat, { masks } from "dateformat";
import {
  encryptValue,
  parseAndDecryptFromState,
  buildEncryptedQueryString,
} from "../../../components/Encryption/cryptoUtils";
const extendedMoment = extendMoment(moment);
const auth = new HelperClass();

class ViewClientAnalytics extends Component {
  constructor() {
    super();
    const today = extendedMoment();
    const monthAgo = moment().subtract(7, "day");
    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      formLoader: true,
      errorMessage: "",
      errorMessageTitle: "",
      successMessage: "",
      title: "",
      start_date: monthAgo.format("MMMM DD, YYYY"),
      end_date: today.format("MMMM DD, YYYY"),
      value: moment.range(monthAgo, today),
      description: "",
      add_picture: "",
      report_id: "",
      added_file: [],
      isEditorReady: false,
      add_pictures: [],
      add_picture_names: [],

      iframe_url: "",
      timeLeft: 600, // 10 minutes = 600 seconds
      showPopup: false,
    };
    this.timerInterval = null;
  }

  async componentDidMount() {
    this.setState({
      tableLoader: true,
      tableLoaderListing: false,
    });

    const url = new URL(window.location.href);
    const pathname = url.pathname; // e.g., "/viewAdminReport/163"
    const queryString = url.search;
    //console.log("pathname: ", pathname);

    if (queryString && queryString.length > 1) {
      const { encPart, restPart } = this.separateEncFromURL(queryString);
      let decrypt_parameters = this.decrypt_parameters(encPart);
      if (decrypt_parameters) {
        //console.log("queryString: ", queryString);
        //console.log("decrypted_parameters: ", decrypt_parameters);

        const params = decrypt_parameters
          .split("&")
          .map((param) => param.split("="));
        // 2. Extract dash_id and other variables
        let dash_id = null;
        let otherParams = {};

        params.forEach(([key, value]) => {
          const decodedValue = decodeURIComponent(value || "");

          if (key === "dash_id") {
            dash_id = decodedValue;
          } else {
            otherParams[key] = decodedValue;
          }
        });

        //window.$("#modalJumpDashboard").modal("show");
        await this.getJumpRequest(encPart, dash_id, otherParams, restPart);
      } else {
        this.setState({ iframe_url: "not_found", tableLoader: false });
        //window.$("#modalJumpDashboard").modal("show");
      }
    } else {
      this.setState({ iframe_url: "not_found", tableLoader: false });
      //window.$("#modalJumpDashboard").modal("show");
    }
  }

  getJumpRequest = async (queryParams, dash_id, otherParams, restPart) => {
    const saveResponce = await viewJumpClientMetabaseReport(
      auth.getClientAccount(),
      auth.getClientToken(),
      dash_id,
      JSON.stringify(otherParams)
    );
    //console.log("getSingleRequest: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "Not Verified"
    ) {
      this.setState({
        mcqLoader: false,
        tableLoader: false,
      });
    } else if (saveResponce.data.status === 200) {
      let final_url = saveResponce.data.iframeData;
      if (final_url.includes("bordered=true&titled=true")) {
        final_url = final_url.replace(/#bordered=true&titled=true&?/, "");
      }
      if (final_url.includes("#bordered=true&titled=true&")) {
        return final_url.replace("#bordered=true&titled=true&", "");
      }
      if (final_url.includes("#bordered&titled")) {
        return final_url.replace("#bordered&titled", "");
      }
      let updatedUrl = final_url;
      if (restPart !== "") {
        updatedUrl = updatedUrl + "?" + restPart + "#bordered=true&titled=true";
      } else {
        updatedUrl = updatedUrl + "#bordered=true&titled=true";
      }

      this.setState({
        //iframe_url: saveResponce.data.iframeData + "&" + restPart,
        iframe_url: updatedUrl,
        tableLoader: false,
      });
      this.startTimer();
    } else {
      this.setState({
        mcqLoader: false,
        tableLoader: false,
      });
    }
  };

  decrypt_parameters = (extra_params) => {
    //const { extra_params } = this.state;
    const parsedParams = parseAndDecryptFromState(extra_params);
    if (parsedParams) {
      //console.log("Decrypted & Parsed Params:", parsedParams);
      return parsedParams;
      // Example: { dash_id: "234", date_filter: "2025-06-16", company_name: "ABC Company" }
    } else {
      console.warn("Invalid or incomplete query string.");
    }
  };

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  startTimer = () => {
    this.timerInterval = setInterval(() => {
      this.setState(
        (prevState) => ({ timeLeft: prevState.timeLeft - 1 }),
        () => {
          const { timeLeft } = this.state;

          // Show popup when timeLeft reaches 30 seconds
          if (timeLeft === 30) {
            this.setState({ showPopup: true });
          }

          // When time runs out, reload the page automatically
          if (timeLeft <= 0) {
            clearInterval(this.timerInterval);
            window.location.reload();
          }
        }
      );
    }, 1000);
  };

  handleReload = () => {
    window.location.reload();
  };

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  close_window = () => {
    const closeResult = window.close();
    if (
      closeResult === false ||
      window.location.href.indexOf("about:blank") === -1
    ) {
      window.location.href = document.referrer || "/";
    }
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ description: updatedContent });
  };

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "processing") {
      return (
        <div>
          <span className="badge badge-dim badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> In process
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Processed
          </span>
        </div>
      );
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeCheckbox = (input) => (e) => {
    this.setState({
      [input]:
        e.target.type === "checkbox" ? e.target.checked : e.target.checked,
    });
    //console.log("handleChangeCheckbox: ", input);
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  addMenuHistory = (link) => {
    this.props.history.push(link);
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("MMMM DD, YYYY"),
      end_date: value.end.format("MMMM DD, YYYY"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

    if (!selectedFiles.length) return; // No files selected

    // File type validation
    const allowedFileTypes = [".txt", ".pdf", ".csv", ".xlsx", ".xls", ".zip"];
    const invalidFiles = selectedFiles.filter(
      (file) =>
        !allowedFileTypes.includes(
          `.${file.name.split(".").pop().toLowerCase()}`
        )
    );

    if (invalidFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Invalid file type detected. Please select valid files.",
      });
      return;
    }

    // File size validation (50MB max per file)
    const maxSizeBytes = 50 * 1024 * 1024;
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > maxSizeBytes
    );

    if (oversizedFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Some files exceed the 50MB limit. Choose smaller files.",
      });
      return;
    }

    // Debugging output to ensure files are being processed correctly
    //console.log("Selected Files: ", selectedFiles);
    //console.log("Current add_pictures in state: ", this.state.add_pictures);

    // Append new files to existing array
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures, ...selectedFiles];
      //console.log("Updated Pictures: ", updatedPictures);
      // **Limit total files to 5**
      if (updatedPictures.length > 5) {
        return {
          docErrorMessage: "You can upload a maximum of 5 files.",
        };
      }
      return {
        add_pictures: updatedPictures,
        docErrorMessage: "", // Clear error message
        add_picture_names: updatedPictures.map((file) => file.name),
      };
    });
  };

  fieldValidationUsername = () => {
    let { title, description } = this.state;

    if (title === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Title is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (description === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Description is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessageTitle: "",
        errorMessage: "",
        disabled: true,
      });
    }
    return true;
  };

  submitRequest = async (e) => {};

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures];
      const updatedNames = [...prevState.add_picture_names];

      // Remove file from both arrays by index
      updatedPictures.splice(index, 1);
      updatedNames.splice(index, 1);

      return {
        add_pictures: updatedPictures,
        add_picture_names: updatedNames,
      };
    });
  };

  handleRemoveAddedFile = (index) => {
    //console.log("handleRemoveAddedFile: ", this.state.added_file);
    this.setState((prevState) => {
      const updatedNames = [...prevState.added_file];

      // Remove file from both arrays by index

      updatedNames.splice(index, 1);
      //console.log("handleRemoveAddedFileAfter: ", updatedNames);
      return {
        added_file: updatedNames,
      };
    });
  };

  separateEncFromURL = (url) => {
    const queryString = url.split("?")[1];
    if (!queryString) return { encPart: "", restPart: "" };

    const params = new URLSearchParams(queryString);

    const encValue = params.get("enc");
    let encPart = "";
    if (encValue) {
      encPart = `?enc=${encodeURIComponent(encValue)}`;
      params.delete("enc");
    }

    // Prepare new URLSearchParams for the rest part
    const newParams = new URLSearchParams();

    for (const [key, value] of params.entries()) {
      // Replace %2C with , and split by ,
      const splitValues = decodeURIComponent(value).split(",");
      for (const val of splitValues) {
        newParams.append(key, val);
      }
    }

    const restPart = newParams.toString(); // Converts remaining params to query string

    return { encPart, restPart };
  };

  render() {
    const { step, isOpen, value, start_date, end_date, showPopup, timeLeft } =
      this.state;

    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}

              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Report" icon="icon ni ni-bar-chart" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <button
                      type="button"
                      onClick={() => this.close_window()}
                      style={{ cursor: "pointer" }}
                      className="btn btn-secondary"
                    >
                      <em className="icon ni ni-cross"></em>{" "}
                      <span>Close Window</span>
                    </button>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        {showPopup && (
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 9999,
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#fff",
                                padding: "30px",
                                borderRadius: "8px",
                                textAlign: "center",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                              }}
                            >
                              <h6>Your session will expire in:</h6>
                              <h1
                                style={{ fontSize: "48px", margin: "20px 0" }}
                              >
                                {this.formatTime(timeLeft)}
                              </h1>
                              <button
                                onClick={this.handleReload}
                                style={{
                                  padding: "10px 20px",
                                  fontSize: "16px",
                                  borderRadius: "4px",
                                  border: "none",
                                  backgroundColor: "#007bff",
                                  color: "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                Reload now
                              </button>
                            </div>
                          </div>
                        )}
                        {/*<ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <a
                              style={{ cursor: "pointer", color: "#fff" }}
                              onClick={() =>
                                this.addMenuHistory("/forms/add_form")
                              }
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus"></em> Add New
                            </a>
                          </li>
                        </ul>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                {this.state.tableLoader === true ? (
                  BarChart()
                ) : (
                  <>
                    {this.state.iframe_url &&
                    this.state.iframe_url === "integration_disabled" ? (
                      <div className="col-md-12">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h6>Metabase integration disabled</h6>
                            <p>
                              Metabase integration is currently disabled. Please
                              contsct administrator to enable it.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : this.state.iframe_url &&
                      this.state.iframe_url === "missing_api_url" ? (
                      <div className="col-md-12">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h6>Metabase API URL Missing</h6>
                            <p>
                              Metabase API URL is missing. Please contact
                              administrator to enable it.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : this.state.iframe_url &&
                      this.state.iframe_url === "not_found" ? (
                      <div className="col-md-12">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h6>Report Not Found</h6>
                            <p>
                              Report you are trying to access is either not
                              active, published or processed.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <iframe
                        src={this.state.iframe_url}
                        height="100%"
                        width="100%"
                        style={{
                          height: "100vh",
                          marginTop: "5px",
                          marginLeft: "-5px",
                          border: "0",
                        }}
                        id="report_iframe"
                      ></iframe>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade completeFlexibleModal"
          tabIndex="-1"
          id="modalJumpDashboard"
        >
          <div
            className="modal-dialog modal-xl modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <div
                  className="modal-title"
                  style={{ textAlign: "center", fontSize: "20px" }}
                >
                  <strong>
                    <em className="icon ni ni-bar-chart"></em>Report{" "}
                  </strong>
                </div>

                <a
                  onClick={() => this.close_window()}
                  style={{ cursor: "pointer" }}
                  className="close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
              </div>

              <div className="modal-body">
                <div className="nk-modal"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ViewClientAnalytics));
